import * as React from "react";
import { useModal, useMount } from "../../../../utils/custom-hooks";
import { useState } from "react";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { OrganizationAclModal } from "../../../organisms/service-provider/modal/organization-acl-modal";
import {
  OrganizationAclServiceProps,
  OrganizationAclService,
} from "../../../../application/service/service-provider/acl-service";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { useParams } from "react-router-dom";
import { ServiceProviderTabs } from "../../../molecules/service-provider-tab";
import { ServiceProviderR } from "../routes";
import {
  AddressSetting,
  displayIpAddress,
} from "../../../../application/domain/acl";
import { OrganizationDeleteAclModal } from "../../../organisms/service-provider/modal/organization-acl-delete-modal";
import {
  DangerButton,
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

export const OrganizationAclSetting: React.FunctionComponent<
  OrganizationAclServiceProps
> = ({
  isLoading,
  acl,
  fetchOrganizationACL,
  onCreateOrganizationACL,
  onUpdateOrganizationACL,
}) => {
  const { id: orgId } = useParams<{ id: string }>();

  useMount(async () => {
    await fetchOrganizationACL(orgId);
  });

  const aclModal = useModal(false);
  const deleteModal = useModal(false);
  const [selectedIdx, setSelectedIdx] = useState<number | undefined>(undefined);

  const onAddIP = (setting: AddressSetting) => {
    if (acl?.id) {
      acl.allowedIpAddresses.push(setting);
      onUpdateOrganizationACL(acl.id, acl.allowedIpAddresses, orgId);
    } else {
      onCreateOrganizationACL([setting], orgId);
    }
  };

  const onUpdateIP = (setting: AddressSetting) => {
    acl!.allowedIpAddresses[selectedIdx!] = setting;
    onUpdateOrganizationACL(acl!.id!, acl!.allowedIpAddresses, orgId);
  };

  const onDeleteIP = async () => {
    acl!.allowedIpAddresses.splice(selectedIdx!, 1);
    onUpdateOrganizationACL(acl!.id!, acl!.allowedIpAddresses, orgId);
    deleteModal.close();
  };

  return (
    <ServiceProviderTemplate
      breadcrumbs={[{ to: ServiceProviderR.Home.link({}), title: "Home" }]}
    >
      <div className="has-text-left">
        <div className="columns is-centered">
          <div className="column">
            <ServiceProviderTabs orgId={orgId} />
            <nav className="level">
              <div className="level-left" />
              <div className="level-right">
                <p className="level-item">
                  <PrimaryButton
                    text={"新規登録"}
                    onClick={() => {
                      setSelectedIdx(undefined);
                      aclModal.open();
                    }}
                  />
                </p>
              </div>
            </nav>
            <div className="table-container">
              <table className="table is-fullwidth">
                <thead>
                  <tr>
                    <th>IPアドレス</th>
                    <th>コメント</th>
                    <th aria-label="更新する"></th>
                    <th aria-label="削除する"></th>
                  </tr>
                </thead>
                <tbody>
                  {acl?.allowedIpAddresses.map((addressSetting, idx) => (
                    <tr key={idx}>
                      <td>{displayIpAddress(addressSetting)}</td>
                      <td>{addressSetting.remarks}</td>
                      <td>
                        <SecondaryButton
                          text={"更新する"}
                          onClick={() => {
                            setSelectedIdx(idx);
                            aclModal.open();
                          }}
                        />
                      </td>
                      <td>
                        <DangerButton
                          text={"削除する"}
                          onClick={() => {
                            setSelectedIdx(idx);
                            deleteModal.open();
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {aclModal.isActive && (
          <OrganizationAclModal
            isLoading={isLoading}
            updateTarget={
              acl && selectedIdx !== undefined
                ? acl.allowedIpAddresses[selectedIdx]
                : undefined
            }
            isActive={aclModal.isActive}
            onModal={aclModal.close}
            onAddIP={onAddIP}
            onUpdateIP={onUpdateIP}
          />
        )}
        {deleteModal.isActive && acl && selectedIdx !== undefined && (
          <OrganizationDeleteAclModal
            isActive={deleteModal.isActive}
            target={acl.allowedIpAddresses[selectedIdx]}
            onDelete={onDeleteIP}
            onModal={deleteModal.close}
          />
        )}
      </div>
    </ServiceProviderTemplate>
  );
};

export const OrganizationAclSettingContainer = connectPageService(
  OrganizationAclSetting,
  () => new OrganizationAclService(),
);
